export default "__VITE_ASSET__DRZlBpvc__"